// extracted by mini-css-extract-plugin
export default {"root":"PjPaitxy","placeholder":"cewWPjoO"};